import voucherStatusMixinJson from '@/data/json/credit/voucher/voucherStatusMixin.json'
import { VoucherStatus } from '@/enums/VoucherStatus.js'

export const voucherStatusMixin = {
  data: vm => ({
    voucherStatusConfig: {
      [VoucherStatus.Loading]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_loading'),
        color: 'primary',
        code: VoucherStatus.Loading
      },
      [VoucherStatus.Activated]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_accept'),
        color: 'success',
        code: VoucherStatus.Activated
      },
      [VoucherStatus.AlreadyActivated]: {
        text: vm.$cms.get(
          voucherStatusMixinJson.data,
          'voucher_already_activated'
        ),
        color: 'orange',
        code: VoucherStatus.AlreadyActivated
      },
      [VoucherStatus.Expired]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_expired'),
        color: 'error',
        code: VoucherStatus.Expired
      },
      [VoucherStatus.NotFound]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_not_found'),
        color: 'error',
        code: VoucherStatus.NotFound
      },
      [VoucherStatus.PermissionFailed]: {
        text: vm.$cms.get(
          voucherStatusMixinJson.data,
          'voucher_permission_failed'
        ),
        color: 'error',
        code: VoucherStatus.PermissionFailed
      },
      [VoucherStatus.UserHasNoAplId]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_no_apl_id'),
        color: 'error',
        code: VoucherStatus.UserHasNoAplId
      },
      [VoucherStatus.Unauthorized]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_unauthorized'),
        color: 'orange',
        code: VoucherStatus.Unauthorized
      },
      [VoucherStatus.Error]: {
        text: vm.$cms.get(voucherStatusMixinJson.data, 'voucher_error'),
        color: 'error',
        code: VoucherStatus.Error
      }
    }
  })
}
